export { default as AcademyIcon } from './academy';
export { default as AngryIcon } from './angry';
export { default as ArchiveIcon } from './archive';
export { default as ArchiveFillIcon } from './archive-fill';
export { default as ArchiveMinusIcon } from './archive-minus';
export { default as ArrowIcon } from './arrow';
export { default as AttachmentIcon } from './attachment';
export { default as BotIcon } from './bot';
export { default as BriefCaseIcon } from './briefcase';
export { default as CInstaClubVector } from './c-instaclub-vector';
export { default as CalenderIcon } from './calender';
export { default as CheckMarkIcon } from './check-mark';
export { default as CheckMarkCircle } from './check-mark-circle';
export { default as ChevronIcon } from './chevron';
export { default as ClockIcon } from './clock';
export { default as ClockDotsIcon } from './clock-dots';
export { default as CloseIcon } from './close';
export { default as CoffeeIcon } from './coffee';
export { default as CommentIcon } from './comment';
export { default as CommentFillIcon } from './comment-fill';
export { default as CopyIcon } from './copy';
export { default as CrownIcon } from './crown';
export { default as CrownOutIcon } from './crown-out';
export { default as DashboardIcon } from './dashboard';
export { default as DateCategoryIcon } from './data-cetegory';
export { default as DecreaseIcon } from './decrease';
export { default as EyeIcon } from './eye';
export { default as FilterIcon } from './filter';
export { default as FolderIcon } from './folder';
export { default as FolderOpenIcon } from './folder-open';
export { default as GalleryIcon } from './gallery';
export { default as GridIcon } from './grid';
export { default as HappyIcon } from './happy';
export { default as HashtagIcon } from './hashtag';
export { default as HeadPhoneIcon } from './head-phone';
export { default as HeartIcon } from './heart';
export { default as HeartFillIcon } from './heart-fill';
export { default as HomeIcon } from './home';
export { default as HourglassIcon } from './hourglass';
export { default as IncreaseIcon } from './increase';
export { default as InfoIcon } from './info';
export { default as InstaClubTypoLogo } from './insta-club-typo-logo';
export { default as InstagramIcon } from './instagram';
export { default as keyIcon } from './key';
export { default as LeftArrowIcon } from './left-arrow';
export { default as LegacyIcon } from './legacy';
export { default as LikeIcon } from './like';
export { default as LikeFillIcon } from './like-fill';
export { default as LinkIcon } from './link';
export { default as LoadingIcon } from './loading';
export { default as LockIcon } from './lock';
export { default as LoveIcon } from './love';
export { default as MenuIcon } from './menu';
export { default as MessageIcon } from './message';
export { default as MessageQuestionIcon } from './message-question';
export { default as MessageTextIcon } from './message-text';
export { default as MicroPhoneIcon } from './microphone';
export { default as ModernIcon } from './modern';
export { default as MonitorIcon } from './monitor';
export { default as NeutralIcon } from './neutral';
export { default as NoteIcon } from './note';
export { default as NoteCheckIcon } from './note-check';
export { default as NotificationIcon } from './notification';
export { default as PaperclipIcon } from './paperclip';
export { default as PauseIcon } from './pause';
export { default as PenIcon } from './pen';
export { default as PinIcon } from './pin';
export { default as PlayIcon } from './play';
export { default as PlusIcon } from './plus';
export { default as ProgramIcon } from './program';
export { default as ReelVideoIcon } from './reel-video';
export { default as ReelVideoFillIcon } from './reel-video-outline';
export { default as ReelsVideoIcon } from './reels-video';
export { default as RefreshIcon } from './refresh';
export { default as ReplyIcon } from './reply';
export { default as ReportIcon } from './report';
export { default as RightArrowIcon } from './right-arrow';
export { default as SadIcon } from './sad';
export { default as SendIcon } from './send';
export { default as SharpCrownIcon } from './sharp-crwon';
export { default as ShieldIcon } from './shield';
export { default as ShoppingBagIcon } from './shopping-bag';
export { default as SliderIcon } from './slider';
export { default as SparklesIcon } from './sparkles';
export { default as TermsAndConditionsIcon } from './terms-and-conditions';
export { default as TimerIcon } from './timer';
export { default as Toman } from './toman';
export { default as TriangleIcon } from './traiangle';
export { default as TrashIcon } from './trash';
export { default as UserIcon } from './user';
export { default as VerifyIcon } from './verify';
export { default as VideoIcon } from './video';
export { default as VideoCircle } from './video-circle';
export { default as VideoPlayIcon } from './video-play';
export { default as VolumeHighIcon } from './volume-high';
export { default as VolumeSlashIcon } from './volume-slash';
export { default as WalletIcon } from './wallet';
